import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  LocalizePropType,
  selectBrandSettings,
  selectUser,
  setShowHomeWT,
  withTextLocalizer,
} from 'getaway-data-layer';
import HomeView from './DesktopWTView';
import { navigateTo } from '../../../utils';
import { showAboutDialog } from '../../../utils/dialogsHelpers';
import { useHistory } from 'react-router-dom';
import config from '../../../env.config';
import packageInfo from '../../../../package.json';

type Props = {
  localize: LocalizePropType;
};
const DesktopWTContainer = ({ localize }: Props) => {
  const dispatch = useDispatch();
  // @ts-ignore
  const sliderRef = useRef();
  const history = useHistory();
  const user = useSelector(selectUser);
  const brandSettings = useSelector(selectBrandSettings);
  const [sliderIndex, setSliderIndex] = useState(0);

  const isSignInWithEmailEnabled =
    brandSettings?.accountSettings?.signInWithEmailEnabled;

  const afterSlide = (index: number) => {
    setSliderIndex(index);
  };

  const onClickLogin = () => {
    dispatch(setShowHomeWT(false));
    isSignInWithEmailEnabled && window.location.hostname !== 'localhost'
      ? navigateTo(history, '/email-login')
      : navigateTo(history, '/login');
  };

  const onClickVersionHeader = () => {
    showAboutDialog(
      config.brand.xBrandId!!,
      localize,
      `© GETAWAY・v${packageInfo.version}`
    );
  };

  const onClickNext = () => {
    dispatch(setShowHomeWT(false));
    navigateTo(history, '/signup');
  };

  return (
    <HomeView
      localize={localize}
      user={user!}
      sliderIndex={sliderIndex}
      sliderRef={sliderRef}
      afterSlide={afterSlide}
      onClickVersionHeader={onClickVersionHeader}
      onClickLogin={onClickLogin}
      onClickNext={onClickNext}
    />
  );
};

export default withTextLocalizer(DesktopWTContainer);
